type GroupList = {
    [key: string]: string; // This dictionary maps strings to numbers
};

const reversableGroups: GroupList = {
    OAc: "AcO",
    CN: "NC",
    NO2: "O2N",
    MgBr: "BrMg",
    OTs: "TsO",
    OTf: "TfO",
    OMs: "MsO",
    PPh3: "Ph3P",
    SnBu3: "Bu3Sn",
    OMe: "MeO",
    OEt: "EtO"
}

export const getReversableGroup = (symbol:  string) => {
    return reversableGroups[symbol];
}